import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IOrganizationState } from './organization.reducer';
import { organizationKey } from './organization.actions';

const select = createFeatureSelector<IOrganizationState>(organizationKey);

export const selectOrgProfile = createSelector(
  select,
  (state) => state.profile
);

export const selectOrgReview = createSelector(select, (state) => state.reviews);

export const selectOrgMembers = createSelector(select, (state) => ({
  members: state.members,
  count: state.membersCount
}));

export const selectOrgClubs = createSelector(select, (state) => state.clubs);

export const selectOrgJobs = createSelector(select, (state) => state.jobs);

export const selectOrgChapters = createSelector(
  select,
  (state) => state.chapters
);
